import Cookies from 'js-cookie'
import { userManager } from './oidc-support/utils'
import R from 'ramda'

export const getMetaConfig = (metaName, defaultValue) => {
  if (window == null || window.document == null) return null
  const metaData = window.document.getElementsByTagName('meta')
  for (let i = 0; i < metaData.length; i++) {
    if (metaData[i].getAttribute('name') === metaName) {
      const value = metaData[i].getAttribute('content')
      return value == null || value.trim().length === 0 ? defaultValue : value
    }
  }
  return defaultValue
}

export const cookieName = getMetaConfig('integJwtCookieName')
export const useCookie = cookieName != null
export const JWT_KEY = 'pgads-jwt'

export const getEffectiveJwt = () =>
  useCookie ? Cookies.get(cookieName) : window?.localStorage?.getItem(JWT_KEY)

export const finalizeLogout = (reload = true) => {
  if (useCookie) {
    console.log('removing cookie', cookieName)
    Cookies.remove(cookieName, {
      path: '/',
      domain: getMetaConfig('integJwtCookieDomain'),
    })
  } else {
    if (window?.localStorage != null) window.localStorage.removeItem(JWT_KEY)
  }
  if (reload) if (window?.location != null) window.location.reload()
}

export const processLogout = () => {
  const skipOidcSingout =
    getMetaConfig('oidcSkipIdpSignout', 'false') === 'true'
  if (window?.localStorage != null) window.localStorage.removeItem(JWT_KEY)
  if (userManager == null) {
    finalizeLogout(true)
  } else {
    if (skipOidcSingout) finalizeLogout(true)
    else {
      userManager
        .getUser()
        .then(user => {
          userManager.signoutRedirect({
            id_token_hint: user.id_token,
          })
        })
        .finally(_ => finalizeLogout(true))
    }
  }
}

export const getIsPasswordDisabled = envConfig => {
  const ldapEnabled = (envConfig || {}).ldapEnabled || false
  const msClientId = getMetaConfig('msClientId', '')
  const oidcClientId = getMetaConfig('oidcClientId', '')

  const passwordDisabled =
    ldapEnabled ||
    userManager != null ||
    !R.isEmpty(R.trim(msClientId || '')) ||
    !R.isEmpty(R.trim(oidcClientId || ''))

  return passwordDisabled
}
